/* src/app/client-detail/client-detail.component.scss */
.form-group {
  text-align: left;
}
.form-control {
  height: 35px;
}
::ng-deep .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  padding: 0px !important;
}
::ng-deep .mat-mdc-form-field .mat-mdc-form-field-flex {
  padding: 0px !important;
}
.client-detail {
  background: white;
  padding: 20px;
  border-radius: 8px;
  color: black;
}
.client-detail select {
  width: 100%;
  padding: 5px;
}
.client-detail input,
.client-detail select,
.client-detail textarea {
  color: black !important;
  background-color: white !important;
  border: 1px solid #ccc;
}
.client-detail .tags-section {
  border-top: 1px solid #e0e0e0;
  padding-top: 16px;
  margin-top: 8px;
}
.client-detail .tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 5px;
  margin-bottom: 8px;
  min-height: 28px;
}
.client-detail .no-tags-label {
  font-size: 13px;
  color: #999;
  line-height: 28px;
}
.client-detail .tag-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 4px 12px;
  background-color: #E8F5E9;
  color: black;
  border-radius: 16px;
  font-size: 13px;
}
.client-detail .tag-chip .tag-remove {
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  opacity: 0.75;
  margin-left: 2px;
}
.client-detail .tag-chip .tag-remove:hover {
  opacity: 1;
}
.client-detail .tag-input {
  width: 100%;
  margin-bottom: 8px;
}
.client-detail .tag-checklist {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 180px;
  overflow-y: auto;
  margin-top: 8px;
}
.client-detail .tag-checklist-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}
.client-detail .tag-checklist-item:last-child {
  border-bottom: none;
}
.client-detail .tag-checklist-item:hover {
  background: #fafafa;
}
.client-detail .tag-checklist-item.applied {
  color: #888;
}
.client-detail .tag-checklist-item.tag-create {
  color: #007bff;
  font-style: italic;
}
.client-detail .tag-checklist-item.tag-empty {
  color: #999;
  cursor: default;
}
.client-detail .tag-checklist-item.tag-empty:hover {
  background: none;
}
.client-detail .tag-check-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #555;
  flex-shrink: 0;
}
.client-detail .kind-toolbar {
  display: flex;
  gap: 10px;
  margin-top: 5px;
}
.client-detail .kind-toolbar .kind-option {
  padding: 8px 16px;
  border: 1px solid #ccc;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
  background-color: #f5f5f5;
}
.client-detail .kind-toolbar .kind-option:hover {
  background-color: #e0e0e0;
}
.client-detail .kind-toolbar .kind-option.active {
  background-color: #3f51b5;
  color: white;
  border-color: #3f51b5;
}
/*# sourceMappingURL=client-detail.component.css.map */
